var globalFunctions = require('./globalFunctions.js');
module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title-long">'+
                        'EVENTS'+
                    '</div> '+
                     '<div class="games-table-header games-table-tree">'+
                        '<ul>'+
                            '<li>I 1</li> '+
                            '<li>I X</li> '+
                            '<li>I 2</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-tree">'+
                        '<ul>'+
                            '<li>I 1X</li> '+
                            '<li>I 12</li> '+
                            '<li>I X2</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>I GG</li> '+
                            '<li>I NG</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title-long">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                        '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-betType="I 1" data-betCode="301" class="bet-choose" data-odd="'+quotes.HT1_1+'">'+globalFunctions.checkQuotes(quotes.HT1_1)+'</li> '+
                                '<li data-betType="I X" data-betCode="300" class="bet-choose" data-odd="'+quotes.HT1_X+'">'+globalFunctions.checkQuotes(quotes.HT1_X)+'</li> '+
                                '<li data-betType="I 2" data-betCode="302" class="bet-choose" data-odd="'+quotes.HT1_2+'">'+globalFunctions.checkQuotes(quotes.HT1_2)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-betType="I 1X" data-betCode="810" class="bet-choose" data-odd="'+quotes.HT1_1X+'">'+globalFunctions.checkQuotes(quotes.HT1_1X)+'</li> '+
                                '<li data-betType="I 12" data-betCode="812" class="bet-choose" data-odd="'+quotes.HT1_12+'">'+globalFunctions.checkQuotes(quotes.HT1_12)+'</li> '+
                                '<li data-betType="I X2" data-betCode="802" class="bet-choose" data-odd="'+quotes.HT1_X2+'">'+globalFunctions.checkQuotes(quotes.HT1_X2)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="I GG" data-betCode="511" class="bet-choose" data-odd="'+quotes.HT1_GG+'">'+globalFunctions.checkQuotes(quotes.HT1_GG)+'</li> '+
                                '<li data-betType="I NG" data-betCode="510" class="bet-choose" data-odd="'+quotes.HT1_NG+'">'+globalFunctions.checkQuotes(quotes.HT1_NG)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/first_half_score.js
// module id = 2020
// module chunks = 4